<template>
    <div>
        <!-- Hero Section -->
        <section class="hero">
            <div class="container">
                <h1>Welcome to the Roadlink GLB Platform</h1>
                <p>
                    Global Market Entry,  Assured ｜ 1,000+ World-Class Partners, One Seamless Journey
                </p>
            </div>
        </section>
        
        <Predict ref="predict" />

        <!-- Services Section -->
        <section class="services">
            <div class="container">
                <div class="services-wrapper">
                    <div class="services-content">
                        <div class="section-title">
                            <h2>Your Gateway to China & Southeast Asia</h2>
                            <p>Pinpoint optimal markets. Execute China / Southeast Asia entry missions. Secure partnerships and supply chains</p>
                        </div>
                        <div class="services-list">
                            <div class="service-item">
                                <div class="service-icon">
                                    <img src="../assets/service_search.png" alt="Market Diagnosis" />
                                </div>
                                <div class="service-text">
                                    <div class="service-title">Market Diagnosis</div>
                                    <div class="service-desc">Input Industry/Product/Objectives → pinpointed markets + risk-opportunity analysis, and strategic rationale</div>
                                </div>
                            </div>
                            <div class="service-item">
                                <div class="service-icon">
                                    <img src="../assets/service_calendar.png" alt="Market Entry" />
                                </div>
                                <div class="service-text">
                                    <div class="service-title">Market Entry & Inspection</div>
                                    <div class="service-desc">End-to-end execution—policy navigation, compliance setup, site selection, in-market scouting (China & Southeast Asia)</div>
                                </div>
                            </div>
                            <div class="service-item">
                                <div class="service-icon">
                                    <img src="../assets/service_shake.png" alt="Partnership" />
                                </div>
                                <div class="service-text">
                                    <div class="service-title">Partnership Facilitation</div>
                                    <div class="service-desc">
                                        Secure supply chains, distribution channels & B2B alliances, powered by 70,000+ enterprise network
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="details-button">
                            <router-link to="/news" class="details-link">
                                View Details >>
                            </router-link>
                        </div>
                    </div>
                    <div class="services-image">
                        <img src="../assets/connect.png" alt="Market Entry Services" />
                    </div>
                </div>
            </div>
        </section>

        <!-- Featured Products Section -->
        <section class="featured-products">
            <div class="container">
                <div class="fp-head">
                    <div class="section-title">
                        <h2>Featured Products</h2>
                        <p>Curated solutions to accelerate your global market entry.</p>
                    </div>
                    <span class="fp-more" v-if="productList.length" @click="$router.push('/products')">View All ›</span>
                </div>
                <div class="fp-grid" v-if="productList.length">
                    <div
                        v-for="item in productList"
                        :key="item.id"
                        class="fp-card"
                        @click="$router.push('/product/' + item.id)"
                    >
                        <div class="fp-cover">
                            <span class="fp-tag" v-if="item.category">{{ item.category }}</span>
                            <img v-if="item.cover" :src="item.cover" :alt="item.name" @error="onImgError" />
                            <span v-else class="fp-letter">{{ item.name.slice(0, 1) }}</span>
                        </div>
                        <div class="fp-body">
                            <div class="fp-title">{{ item.name }}</div>
                            <div class="fp-desc">{{ item.summary }}</div>
                            <div class="fp-source" v-if="item.sourceCountry">Source: {{ item.sourceCountry }}</div>
                            <div class="fp-btn">View Details</div>
                        </div>
                    </div>
                </div>
                <div class="fp-empty" v-else>Coming soon.</div>
            </div>
        </section>

        <!-- Stats Section -->
        <section class="stats">
            <div class="container">
                <div class="stats-grid">
                    <StatCard icon="status_network.png" icon-type="image"
                        number="Unlock 170+ Markets. One Elite Network"
                        description="From ministries to industrial parks to global trade chambers—our relationships are your fast-pass to policy clarity, market access, and thriving ecosystems worldwide" />
                    <StatCard icon="status_build.png" icon-type="image"
                        number="13 Years Navigating Global Markets"
                        description="100,000+ clients. 3,000+ premium members. $5B+ in client financing secured" />
                    <StatCard icon="status_praise.png" icon-type="image"
                        number="70,000+ enterprise clients served"
                        description="1,000+ cross-border transactions facilitated. Proven risk & compliance frameworks, drawn from 70,000+ real-world cases" />
                    <StatCard icon="status_computer.png" icon-type="image"
                        number="Policy & Resource Intelligence Engine"
                        description="Forged from 13 years of client engagements and 70,000+ real-world cases. Continuously refined by live market feedback" />
                </div>
            </div>
        </section>

        <history-cases></history-cases>

        <ContactsUs ref="contactsUs" />
    </div>
</template>

<script>
    import StatCard from '../components/modals/shared/StatCard.vue';
    import Predict from '../components/Predict.vue';
    import ContactsUs from '../components/ContactsUs.vue';
    import HistoryCases from '../components/HistoryCases.vue';
    import { fetchProducts } from '../services/home';

    export default {
        name: 'Home',
        components: {
            StatCard,
            HistoryCases,
            ContactsUs,
            Predict
        },
        data() {
            return {
                productList: []
            }
        },
        async created() {
            try {
                this.productList = await fetchProducts()
            } catch (e) {
                this.productList = []
                this.$toast.show({ message: (e && e.message) || 'Failed to load products', type: 'error' })
            }
        },
        methods: {
            openDocument(doc) {
                // 在实际应用中，这里会打开PDF或跳转到链接
                window.open(doc.url, '_blank')
            },
            onImgError(e) {
                e.target.style.display = 'none'
            }
        }
    }
</script>

<style scoped>
    /* 基础样式 */
    .container {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
    }

    /* Hero Section */
    .hero {
        background: url('../assets/home_banner.jpg');
        background-size: cover;
        background-position: center;
        color: white;
        padding: 100px 0;
        text-align: center;
    }

    .hero h1 {
        font-size: 36px;
        margin-bottom: 20px;
        line-height: 1.2;
    }

    .hero p {
        font-size: 16px;
        max-width: 700px;
        margin: 0 auto 27px;
        line-height: 1.5;
    }

    /* Stats Section */
    .stats {
        padding: 60px 0;
        background-color: #2444CB;
    }

    .stats-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
    }

    /* Services Section */
    /* Services Section - 修复响应式布局 */
    .services {
        padding: 60px 0;
        background-color: white;
    }

    .services-wrapper {
        display: grid;
        grid-template-columns: 1.2fr 1fr;
        gap: 80px;
        align-items: center;
    }

    .services-content {
        display: flex;
        flex-direction: column;
    }

    .services-list {
        display: flex;
        flex-direction: column;
        gap: 25px;
        margin-top: 30px;
    }

    .service-item {
        display: flex;
        align-items: flex-start;
        gap: 20px;
    }

    .service-icon {
        width: 42px;
        height: 42px;
        border-radius: 100px;
        border: 2px solid #DDDDDD;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    }

    .service-icon img {
        width: 20px;
        height: 20px;
    }

    .service-text {
        flex: 1;
    }

    .service-title {
        font-size: 26px;
        color: #222222;
        margin-bottom: 8px;
        font-weight: 600;
    }

    .service-desc {
        font-size: 16px;
        color: #222222;
        line-height: 1.5;
    }

    .details-button {
        width: 200px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #265FFF;
        border-radius: 8px;
        margin-top: 40px;
    }

    .details-link {
        font-size: 14px;
        color: white;
        text-decoration: none;
        font-weight: 500;
    }

    .services-image {
        width: 100%;
        height: auto;
        border-radius: 8px;
        overflow: hidden;
        /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
        padding-top: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .services-image img {
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    /* Diagnosis Section */
    .diagnosis {
        padding: 100px 0;
        background-color: #2444CB;
    }

    .diagnosis .section-title h2 {
        font-size: 44px;
        color: white;
    }

    .diagnosis .section-title p {
        font-size: 16px;
        color: white;
    }

    .title-decoration {
        height: 12px;
        width: 60px;
        background-color: #FF9E1B;
        margin-bottom: 16px;
    }

    .diagnosis-container {
        margin: 0 auto;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .diagnosis-form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
    }

    /* 下拉框样式调整 */
    .form-group {
        position: relative;
    }

    .form-group select {
        width: 100%;
        font-size: 16px;
        padding: 12px 16px;
        border: 1px solid #ddd;
        border-radius: 4px;
        box-sizing: border-box;
        /* 移除默认箭头并添加自定义样式 */
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: calc(100% - 12px) center;
        /* 向左移动20px */
        background-size: 16px;
        padding-right: 40px;
        /* 增加右侧内边距为箭头留空间 */
    }

    /* 单独设置联系表单的placeholder颜色 */
    .contact-form input::placeholder,
    .contact-form textarea::placeholder,
    .contact-form select:invalid {
        color: black;
    }

    .contact-form select option[value=""] {
        color: black;
    }

    .form-buttons {
        grid-column: 1 / -1;
        display: flex;
        gap: 15px;
        margin-top: 20px;
    }

    .btn-primary {
        background-color: #FF9E1B;
        color: black;
        border: none;
        padding: 12px 24px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        flex: 1;
    }

    .btn-secondary {
        background-color: transparent;
        color: white;
        border: 1px solid white;
        padding: 12px 24px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        flex: 1;
    }

    /* Analysis Section */
    .analysis-recommend {
        padding: 60px 0;
        background-color: white;
    }

    .analysis-recommend h3 {
        font-size: 32px;
        color: #222222;
        margin-bottom: 30px;
    }

    .analysis-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 30px;
        margin-top: 44px;
    }

    .analysis-item {
        border: 1px solid #2444CB;
        border-radius: 8px;
        padding: 10px 0px;
        background-color: white;
        display: flex;
        flex-direction: column;
    }

    .analysis-header {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        /* height: 40px; */
        padding: 15px 20px;
    }

    .analysis-header img {
        height: 23px;
        width: 23px;
    }

    .analysis-header p {
        margin-left: 10px;
        font-family: Arial, Arial;
        font-weight: normal;
        font-size: 18px;
        color: #222222;
        line-height: 24px;
        font-style: normal;
        text-transform: none;
    }

    .divider {
        height: 1px;
        background-color: #2444CB;
        width: 100%;
        margin: 0 0;
    }

    .analysis-content {
        display: flex;
        flex-direction: column;
        padding: 25px;
        /* 增加内边距，使文字与边框距离增加 */
        font-size: 16px;
        flex: 1;
    }

    .content-label {
        color: #303030;
        margin-bottom: 12px;
        /* 增加标签与内容框之间的距离 */
    }

    .content-box {
        /* height: 50px; */
        display: flex;
        align-items: center;
        margin-bottom: 18px;
        /* 增加内容框之间的间距 */
    }

    .empty-text {
        color: #999999;
    }

    .filled-box {
        border: 2px solid #2444CB;
        border-radius: 6px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 14px;
        padding: 10px 20px;

        height: auto; /* 不再填满父节点，让 padding 生效并扩高 */
        box-sizing: border-box;
        /* 为填充框内的文字增加内边距 */
    }

    .filled-box p {
        color: #2444CB;
        margin: 0;
    }

    .contact-link {
        display: flex;
        align-items: left;
        font-size: 14px;
        margin-top: 15px;
        /* 增加联系链接的顶部间距 */
    }

    .contact-link a {
        color: #265FFF;
        text-decoration: none;
    }

    .report-buttons {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 15px;
        margin-top: 10px;
        padding: 10px 20px;
    }

    .btn-outline {
        background-color: white;
        border: 1px solid #265FFF;
        color: #265FFF;
        padding: 12px 24px;
        border-radius: 4px;
        font-family: PingFang-SC, PingFang-SC;
        font-weight: 800;
        font-size: 14px;
        font-style: normal;
        height: 40px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    /* Related Services */
    .related-services {
        padding: 60px 0;
        background-color: #2444CB;
        width: 100%;
    }

    .related-services .section-title h2 {
        font-size: 24px;
        color: white;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
    }

    .services-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
        gap: 30px;
        width: 100%;
    }

    .service-card {
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .card-header {
        background-color: #265FFF;
        color: white;
        padding-left: 31px;
    }

    .card-header h3 {
        margin: 0;
        font-size: 24px;
        font-family: Arial, Arial;
        font-weight: normal;
        height: 60px;
        display: flex;
        align-items: center;
    }

    .card-content {
        padding: 20px 25px 0 31px;
    }

    .card-content ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .card-content li {
        margin-bottom: 12px;
        padding-left: 20px;
        position: relative;
        font-size: 16px;
        line-height: 1.4;
    }

    .card-content li:before {
        content: "•";
        color: #265FFF;
        font-weight: bold;
        position: absolute;
        left: 0;
    }

    /* Featured Documents */
    .featured-documents {
        padding: 60px 0;
        background-color: white;
    }

    .documents-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 30px;
    }

    .document-card {
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .document-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    }

    .document-image {
        height: 200px;
        overflow: hidden;
    }

    .document-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .document-summary {
        padding: 20px;
    }

    .document-summary p {
        margin-bottom: 10px;
        line-height: 1.5;
        font-size: 16px;
    }

    .document-date {
        color: #222222;
        font-size: 12px;
    }

    /* Success Stories */
    .success-stories {
        padding: 60px 0;
        background-color: #2444CB;
    }

    .success-stories .section-title h2 {
        color: white;
        font-size: 32px;
    }

    .stories-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 30px;
    }

    .story-card {
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .story-content {
        display: flex;
        flex-direction: column;
        height: 220px;
        background: url('../assets/light_bg.png');
        background-size: cover;
        background-position: center;
        padding: 25px;
    }

    .story-content h3 {
        padding: 0;
        font-size: 20px;
        color: #222222;
        height: 60px;
        margin: 0;
        display: flex;
        align-items: center;
    }

    .story-description {
        height: 160px;
    }

    .story-description p {
        font-size: 18px;
        color: #222222;
        line-height: 1.4;
        margin: 0;
    }

    /* Contact Section */
    .contact {
        padding: 60px 0;
        background-color: #022A4E;
    }

    .contact-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 50px;
    }

    .footer-links {
        display: flex;
        gap: 35px;
        margin-top: auto; /* 这将把链接推到容器底部 */
        padding-top: 30px;
    }

    .footer-link {
        color: #b3cde0;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s ease;
    }

    .footer-link:hover {
        color: white;
    }

    /* 确保contact-info使用flex布局以支持底部对齐 */
    .contact-info {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .contact-info .section-title h2 {
        font-size: 44px;
        color: white;
    }

    .contact-info .section-title p {
        color: white;
        font-size: 16px;
        line-height: 1.5;
    }

    .contact-details {
        margin-top: 30px;
        color: white;
    }

    .contact-details p {
        margin-bottom: 10px;
    }

    .social-links {
        margin-top: 30px;
    }

    .social-icons {
        display: flex;
        gap: 20px;
    }

    .social-icons a img {
        height: 31px;
        width: 31px;
    }

    .contact-form {
        background-color: white;
        padding: 30px;
        border-radius: 8px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .contact-form h3 {
        color: #1a3a5f;
        margin-bottom: 20px;
        font-size: 24px;
    }

    .contact-form .form-group {
        margin-bottom: 20px;
        position: relative;
    }

    .contact-form input,
    .contact-form select,
    .contact-form textarea {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 16px;
        box-sizing: border-box;
    }

    /* 为联系表单的下拉框也应用相同的样式 */
    .contact-form select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: calc(100% - 12px) center;
        background-size: 16px;
        padding-right: 40px;
    }

    .contact-form .btn-primary {
        background-color: #265FFF;
        width: 100%;
        color: white;
    }

    /* Report Modal */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .report-modal {
        background-color: white;
        padding: 30px;
        border-radius: 8px;
        max-width: 600px;
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
    }

    .report-content {
        margin: 20px 0;
        line-height: 1.6;
    }

    /* 响应式设计 */
    @media (max-width: 1200px) {
        .container {
            padding: 0 40px;
        }

        .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            /* 中等屏幕显示2列 */
        }

        .services-wrapper {
            gap: 60px;
        }

        .service-title {
            font-size: 24px;
        }
    }

    @media (max-width: 992px) {
        .contact-container {
            grid-template-columns: 1fr;
            gap: 30px;
        }

        .diagnosis-form {
            grid-template-columns: 1fr;
        }

        .services-wrapper {
            grid-template-columns: 1fr;
            gap: 50px;
        }

        .services-image {
            order: -1;
            /* 图片在上方 */
            max-width: 500px;
            margin: 0 auto;
        }

        .services-content {
            text-align: center;
        }

        .service-item {
            justify-content: center;
            text-align: left;
        }

        .details-button {
            margin: 40px auto 0;
        }
    }

    @media (max-width: 768px) {
        .container {
            padding: 0 20px;
        }

        .hero {
            padding: 40px 0;
        }

        .hero h1 {
            font-size: 28px;
        }

        .hero p {
            font-size: 14px;
        }

        .stats,
        .diagnosis,
        .analysis-recommend,
        .related-services,
        .featured-documents,
        .success-stories,
        .contact {
            padding: 40px 0;
        }

        .stats-grid {
            grid-template-columns: 1fr;
            /* 小屏幕显示1列 */
            gap: 20px;
        }

        .section-title h2 {
            font-size: 24px;
        }

        .diagnosis .section-title h2 {
            font-size: 32px;
        }

        .contact-info .section-title h2 {
            font-size: 32px;
        }

        .services {
            padding: 40px 0;
        }

        .services-wrapper {
            gap: 40px;
        }

        .services-list {
            gap: 20px;
            margin-top: 25px;
        }

        .service-item {
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 15px;
        }

        .service-title {
            font-size: 22px;
        }

        .service-desc {
            font-size: 15px;
        }

        .services-image {
            max-width: 100%;
            height: 370px;
        }

        .analysis-grid {
            grid-template-columns: 1fr;
            gap: 20px;
        }

        .documents-grid {
            grid-template-columns: 1fr;
        }

        .stories-grid {
            grid-template-columns: 1fr;
        }

        .form-buttons {
            flex-direction: column;
        }

        .report-buttons {
            padding: 0 15px;
        }

        .contact-form {
            padding: 20px;
        }
    }

    @media (max-width: 576px) {
        .services-wrapper {
            gap: 30px;
        }

        .service-title {
            font-size: 20px;
        }

        .service-desc {
            font-size: 14px;
        }

        .service-icon {
            width: 38px;
            height: 38px;
        }

        .service-icon img {
            width: 18px;
            height: 18px;
        }

        .details-button {
            width: 100%;
            max-width: 200px;
        }

        .services-image {
            height: 320px;
        }
    }

    @media (max-width: 480px) {
        .hero h1 {
            font-size: 24px;
        }

        .service-title {
            font-size: 18px;
        }

        .service-desc {
            font-size: 14px;
        }

        .services-list {
            gap: 25px;
        }

        .service-item {
            gap: 12px;
        }

        .diagnosis .section-title h2 {
            font-size: 28px;
        }

        .contact-info .section-title h2 {
            font-size: 28px;
        }

        .social-icons {
            justify-content: center;
        }

        .details-button {
            width: 100%;
            max-width: 200px;
            margin-left: auto;
            margin-right: auto;
        }
    }

    /* Featured Products Section */
    .featured-products {
        padding: 60px 0;
        background-color: #f5f7fa;
    }
    .fp-head {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 30px;
    }
    .fp-head .section-title h2 {
        font-size: 30px;
        color: #1a3a5f;
        margin: 0 0 8px;
    }
    .fp-head .section-title p {
        font-size: 15px;
        color: #5b6b8c;
        margin: 0;
    }
    .fp-more {
        font-size: 14px;
        color: #265fff;
        font-weight: 600;
        cursor: pointer;
    }
    .fp-more:hover {
        text-decoration: underline;
    }
    .fp-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
        gap: 22px;
    }
    .fp-card {
        background: #fff;
        border: 1px solid #e6ebf5;
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 6px 22px rgba(38, 95, 255, 0.08);
        transition: transform 0.25s ease, box-shadow 0.25s ease;
        cursor: pointer;
        display: flex;
        flex-direction: column;
    }
    .fp-card:hover {
        transform: translateY(-6px);
        box-shadow: 0 10px 30px rgba(38, 95, 255, 0.16);
    }
    .fp-cover {
        height: 170px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 30px;
        font-weight: 800;
        position: relative;
        overflow: hidden;
    }
    .fp-cover img {
        width: 100%;
        height: 100%;
        /* 等比例完整展示：contain 不裁剪，整张图按比例缩放居中，留白处显示渐变背景 */
        object-fit: contain;
        object-position: center;
        display: block;
        padding: 10px;
        box-sizing: border-box;
    }
    .fp-cover .fp-tag {
        position: absolute;
        top: 12px;
        left: 12px;
        background: rgba(20, 30, 60, 0.82);
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        padding: 3px 10px;
        border-radius: 20px;
    }
    .fp-cover .fp-letter {
        font-size: 30px;
        font-weight: 800;
        color: #265fff;
    }
    .fp-body {
        padding: 16px 18px 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
    .fp-title {
        font-size: 17px;
        font-weight: 700;
        color: #1f2a44;
        margin-bottom: 8px;
    }
    .fp-desc {
        font-size: 13.5px;
        color: #5b6b8c;
        line-height: 1.7;
        flex: 1;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .fp-source {
        margin-top: 12px;
        font-size: 12.5px;
        color: #265fff;
        font-weight: 600;
    }
    .fp-btn {
        margin-top: 14px;
        align-self: center;
        background: #265fff;
        color: #fff;
        font-size: 13.5px;
        font-weight: 600;
        padding: 8px 26px;
        border-radius: 20px;
        transition: background 0.25s;
    }
    .fp-card:hover .fp-btn {
        background: #1a3a5f;
    }
    .fp-empty {
        text-align: center;
        color: #9aa6c0;
        padding: 40px 0;
        background: #f6f8fd;
        border-radius: 12px;
    }
    @media (max-width: 768px) {
        .fp-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
    @media (max-width: 480px) {
        .fp-grid {
            grid-template-columns: 1fr;
        }
    }
</style>